// Returns the orgId to send to Process Core. For tenants migrated from
// auth.zeidman.info to ZeidZone, sessionStorage holds two ids:
//   - 'orgId'        — the new ZeidZone id (used for ZDHub, Config Web, billing,
//                      auth, and anything else identifying the tenant in
//                      Zeidman systems).
//   - 'legacyOrgId'  — the pre-migration id, populated from the OrgEndpoint
//                      response when ZDHub has it set on the row. Process Core's
//                      stored documents are tagged with the legacy id, so until
//                      Phase 3 (Tenant:Mode = Dedicated) lands per tenant,
//                      Process Core requests must continue to use the legacy id
//                      for the orgId filter to match.
//
// For unmigrated tenants, 'legacyOrgId' is absent and this returns the same
// value as sessionStorage.getItem('orgId'). The function is safe to call from
// any code that targets Process Core.
export function getEffectiveOrgId(): string {
  return sessionStorage.getItem('legacyOrgId') ?? sessionStorage.getItem('orgId') ?? '';
}
